// declare const URLS: Urls;

export interface DeakoWindow extends Window {
    URLS: Urls;
    BASE_URL: string;
    API_URL: string;
    ROUTING_BASENAME: string;
    AUTH_CONFIG: AuthConfig;
}

const deakoWindow = window as unknown as DeakoWindow;
export { deakoWindow as window };

interface Urls {
    CLIENT_BASE_URL: string;
    AUTH: {
        LOGIN_PAGE_URI: string;
        LOGOUT_RETURN_TO_URI: string;
        TOKEN_RENEW_CALLBACK_URI: string;
    };
    CUSTOMERS: string;
    GET_CUSTOMER_ADDRESSES: string;
    ORDERS: string;
}

interface AuthConfig {
    domain: string;
    audience: string;
    scope: string;
    responseType: string;
    clientID: string;
    allowedConnections: string[];
}
